import React from "react";

export default function MessageModals({
  message,
  setIsOpen,
  bottom = 25,
  time = 3000,
}) {
  setTimeout(() => {
    setIsOpen(false);
  }, time);

  return (
    <div
      style={{ bottom: `${bottom}vw` }}
      className="absolute w-[94vw] right-1/2 translate-x-[50%] flex items-center justify-center bg-[#F8F8F3] rounded-[1.8vw] py-[1.8vw] z-[3000]"
    >
      <p className="text-[#153038] font-font_primary_A text-[3.5vw] text-center justify-center px-[2vw]">
        {message}
      </p>
    </div>
  );
}
